"use strict";

export function init() {

    const articleSticky = document.querySelector('.article-nav');

    if (articleSticky) {
        const navLinks = Array.from(document.querySelectorAll('.article-nav__link'));

        const sections = document.querySelectorAll('.content-blocks section');
        const sectionsFilter = Array.from(sections).filter(section => section.id);

        // Active state for nav links
        const getSwiper = () => document.querySelector('.article-nav__scroll')?.swiper;

        const setActiveLink = target => {
            navLinks.forEach(link => link.classList.remove('active'));
            target.classList.add('active');

            const swiper = getSwiper();
            const slideEl = target.closest('.swiper-slide');

            if (swiper && slideEl) {
                const slides = Array.from(swiper.slides);
                const index = slides.indexOf(slideEl);
                if (index !== -1) {
                    swiper.slideTo(index);
                }
            } else {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center'
                });
            }
        };

        // Scroll for nav links taking in size of header and alerts
        if (navLinks.length) {
            navLinks.forEach(link => {
                link.addEventListener('click', e => {
                    e.preventDefault();

                    const href = link.getAttribute('href') || '';
                    const targetId = href.split('#')[1];
                    const targetElement = document.getElementById(targetId);
                    if (!targetElement) return;

                    const headerScroll = document.querySelector('.global-group');
                    const articleStickyNav = document.querySelector('.article-nav');

                    const stickyNavHeight = headerScroll ? headerScroll.offsetHeight : 0;
                    const articleNavHeight = articleStickyNav ? articleStickyNav.offsetHeight : 0;

                    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - stickyNavHeight - articleNavHeight;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });

                    setActiveLink(link);
                });
            });
        }

        // Update active state for nav links on scroll
        const updateActiveLinkOnScroll = () => {
            let currentSection = '';

            sectionsFilter.forEach(section => {
                const sectionTop = section.offsetTop;
                const sectionBottom = sectionTop + section.offsetHeight;
                const viewportMiddle = window.scrollY + window.innerHeight / 2;

                if (viewportMiddle >= sectionTop && viewportMiddle < sectionBottom) {
                    currentSection = section.getAttribute('id');
                }
            });

            if (currentSection) {
                const activeLink = navLinks.find(link => {
                    const href = link.getAttribute('href') || '';
                    const id = href.includes('#') ? href.split('#')[1] : null;
                    return id === currentSection;
                });

                if (activeLink && !activeLink.classList.contains('active')) {
                    setActiveLink(activeLink);
                }
            }
        };

        window.addEventListener('scroll', updateActiveLinkOnScroll);
        window.addEventListener('resize', () => {
            updateActiveLinkOnScroll();
        });

        updateActiveLinkOnScroll();
    }

}


